import { render, staticRenderFns } from "./MyNav.vue?vue&type=template&id=02a06978&scoped=true&"
import script from "./MyNav.vue?vue&type=script&lang=js&"
export * from "./MyNav.vue?vue&type=script&lang=js&"
import style0 from "./MyNav.vue?vue&type=style&index=0&id=02a06978&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a06978",
  null
  
)

export default component.exports